// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--pCnia","logo-block":"a10a3f92e9--logo-block--fS4mL","title":"a10a3f92e9--title--oKTMy","title-block":"a10a3f92e9--title-block--uTLcj"};